module.exports = __webpack_public_path__ + "static/media/TC.3886447a.svg";